
export default function formatDateTable(date) {
  const localDate = new Date(date);
  const formattedDate = localDate.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  return date ? `${formattedDate} ` : '--'
}

